import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";

import texts from "./components/locale/text";
import { AppLabelService } from "./services/appLabelService";

export const LANGUAGE_STORAGE_KEY = "language";

type Languages = keyof typeof texts;
type Translations = (typeof texts)["en"];

interface LanguageContextType {
  language: Languages;
  setLanguage: (lang: Languages) => void;
  t: (key: string, params?: Record<string, string | number> | null, _language?: Languages) => string;
  reRenderAnalysisList: boolean;
  setReRenderAnalysisList: (value: boolean) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [language, setLanguage] = useState<Languages>(() => {
    const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (saved === "en" || saved === "fr") return saved;
    return typeof navigator !== "undefined" && navigator.language?.toLowerCase().startsWith("fr") ? "fr" : "en";
  });
  const [reRenderAnalysisList, setReRenderAnalysisList] = useState<boolean>(false);
  const { allLabels} = AppLabelService(language);
  let allLabelsLoad = window?.allTranslatedLabels? window?.allTranslatedLabels: allLabels;
  const t = (key: any, params?: Record<string, string | number> | null, _language?: Languages): string => {
    let ___language = language;
    if (_language) {
      ___language = _language;
    }

    const translations = texts[___language] as Record<string, string>;
    let translation = "";

    if(allLabelsLoad && allLabelsLoad?.[___language]?.[key]){
      translation = allLabelsLoad[___language][key];
    }else {
      translation = translations[key] ?? key;
    }

    if (params) {
      Object.entries(params).forEach(([placeholder, value]) => {
        translation = translation.replace(new RegExp(`{${placeholder}}`, "g"), String(value).trim());
      });
    }

    return translation;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, reRenderAnalysisList, setReRenderAnalysisList }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte
export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
